module.exports = __webpack_public_path__ + "images/emoji/open_book.d657f1ce7e240aeb3a11.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/open_book.png
// module id = /7ti
// module chunks = 14